import { render, staticRenderFns } from "./game.vue?vue&type=template&id=94ef4018&lang=pug"
import script from "./game.vue?vue&type=script&lang=ts"
export * from "./game.vue?vue&type=script&lang=ts"
import style0 from "./game.vue?vue&type=style&index=0&id=94ef4018&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports